import { ChangeDetectionStrategy, Component, input, output, signal } from "@angular/core";
import { S25LoadingInlineStaticComponent } from "../../modules/s25-loading/s25.loading.inline.static.component";
import { AlertService } from "../../services/alert.service";
import { LangService } from "../../services/lang.service";
import { PublisherService } from "../../services/publisher.service";
import { s25Resource } from "../../util/s25.resource";
import { S25IconButtonComponent } from "../s25.icon.button.component";

@Component({
    selector: "s25-ng-publisher-delete-cell",
    template: `
        @if (loading()) {
            <s25-ng-loading-inline-static [text]="''" />
        } @else {
            <s25-ng-icon-button type="close" ariaLabel="Delete" (clicked)="delete($event)" />
        }
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [S25LoadingInlineStaticComponent, S25IconButtonComponent],
})
export class PublisherDeleteCell {
    readonly uid = input.required<number>();
    readonly feedName = input.required<string>();
    readonly calName = input.required<string>();
    readonly refreshed = output<void>();

    protected readonly loading = signal(false);
    private readonly lang = s25Resource(
        async () => (await LangService.getLang()).div.controls["s25-publisher_admin"].text.delete_confirm,
    );

    protected async delete(event?: MouseEvent): Promise<void> {
        event?.stopPropagation();
        if (this.loading()) {
            return;
        }
        const confirmMsg = this.lang
            .value()
            ?.replace("FEED_NAME", this.feedName())
            .replace("CALENDAR_NAME", this.calName());
        if (!confirmMsg || !(await AlertService.confirm(confirmMsg))) {
            return;
        }
        this.loading.set(true);
        try {
            await PublisherService.removeFeed(String(this.uid()));
            this.refreshed.emit();
        } finally {
            this.loading.set(false);
        }
    }
}
